import Button from "components/shared/button";
import useTranslation from "utils/hooks/useTranslation";
import { useEffect, useState } from "react";

import mainBackground from '../assets/img/background_1920.jpg'
import mainBackgroundThermor from '../assets/img/background_thermor_1920.jpg'
import {
    setLocalStorageItem,
} from "utils/helpers/localStorage";
import { setIsInMaintenance as setIsInMaintenanceStore } from "store/commonSlice";
import { useAppDispatch } from "store/hooks";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";


export const Maintenance: React.FC<{
    setIsInMaintenance: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
    setIsInMaintenance
}) => {
        const { t } = useTranslation();
        const { isThermor } = useSalesNetwork()
        const dispatch = useAppDispatch();

        const [clickCount, setClickCount] = useState<number>(0);

        useEffect(() => {
            dispatch(setIsInMaintenanceStore(true));
        }, []);

        useEffect(() => {
            if (clickCount >= 7) {
                setIsInMaintenance(false);
                dispatch(setIsInMaintenanceStore(false));
                setLocalStorageItem("isInMaintenanceOpened", true);
            }
        }, [clickCount]);

        return (
            <view
                //data-space="40"
                data-gap="30"
                data-scroll=""
                //data-background="site"
                data-align="center"
            >
                <group data-height="autofit">
                    <picture data-position="absolute" data-object-fit='cover'><img src={isThermor ? mainBackgroundThermor : mainBackground} alt="" /></picture>
                    <group
                        data-direction="column"
                        data-justify="center"
                        data-align="center"
                    >
                        <group
                            data-border=""
                            data-radius="15"
                            data-contain=""
                            data-background="main-background"
                            data-shrink="no"
                            data-max-length="700"
                        >
                            <group data-space="40">
                                <Button
                                    data-height="60"
                                    data-radius="special"
                                    data-space="20"
                                    data-length="forcefit"
                                    data-fit="1"
                                    primary
                                    text={t("MAINTENANCE_MODE_TITLE")}
                                    onClick={() => {
                                        setClickCount(clickCount + 1);
                                    }}
                                />
                                <space data-height="10"></space>
                                <separator data-horizontal=""></separator>
                                <group>
                                    <text data-wrap="wrap">{t("MAINTENANCE_MODE_TEXT")}</text>
                                </group>
                            </group>
                        </group>
                    </group>
                </group>
            </view>
        );
    };